import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import { tokens } from '@companycam/slab';

import { referencePhotosView } from '../constants';

const NOOP = () => {};

const messages = defineMessages({
  removeReferenceAsset: {
    id: 'Projects.taskList.removeReferenceAsset',
    defaultMessage: 'Remove Reference Image',
    description:
      'Tooltip hover text on the delete icon on a reference photo in a task',
  },
});

// #region styled-components
const Grid = styled.div`
  display: flex;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  width: 100%;
  margin: ${tokens.size_spacing_m}px 0;

  &:empty {
    display: none;
  }
`;

const DeletePhotoIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  color: ${tokens.color_utility_destroy};
  cursor: pointer;
  z-index: 1;
  opacity: 0;

  i {
    top: -5px;
    left: -3px;
    font-size: 24px;
  }
`;

const PhotoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-color: var(--cc_color_background_3);

  &:hover {
    ${DeletePhotoIcon} {
      opacity: 1;
    }
  }
`;

const Photo = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  object-fit: contain;
  object-position: center;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
`;
// #endregion

const ReferenceAssetGrid = ({
  assets = [],
  setSelectedView,
  setReferencePhotoId,
  viewOnly,
}) => {
  const intl = useIntl();
  const handleOnClick = (id) => {
    setReferencePhotoId(id);
    setSelectedView(referencePhotosView.CONFIRM_DELETE);
  };
  return (
    <Grid>
      {assets.map((asset) => (
        <PhotoContainer key={asset.id}>
          {!viewOnly ? (
            <DeletePhotoIcon
              className="hint hint--left"
              aria-label={intl.formatMessage(messages.removeReferenceAsset)}
              onClick={() => handleOnClick(asset.id)}
            >
              <i className="mdi mdi-minus-circle" />
            </DeletePhotoIcon>
          ) : null}
          <Photo key={asset.id} src={asset.thumbnailUrl} disabled={viewOnly} />
        </PhotoContainer>
      ))}
    </Grid>
  );
};

ReferenceAssetGrid.defaultProps = {
  viewOnly: false,
  setReferencePhotoId: NOOP,
  setSelectedView: NOOP,
};

ReferenceAssetGrid.propTypes = {
  assets: PropTypes.array.isRequired,
  setReferencePhotoId: PropTypes.func,
  setSelectedView: PropTypes.func,
  viewOnly: PropTypes.bool,
};

export default ReferenceAssetGrid;
